import React from "react";

type InitScreenProps = {
  title?: string;
  subtitle?: string;
};

export default function InitScreen({
  title = "Initialisierung…",
  subtitle = "Module werden geladen und verbunden.",
}: InitScreenProps) {
  const gold = "#f59e0b";

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        background: "radial-gradient(circle at 50% 0%, #1e1b4b, #02040a 60%)",
        color: "rgba(255,255,255,0.92)",
      }}
    >
      <div
        style={{
          width: "min(560px, 100%)",
          borderRadius: 18,
          padding: "18px 16px",
          background: "rgba(2,4,10,0.72)",
          border: `1px solid rgba(245,158,11,0.22)`,
          boxShadow:
            "0 18px 60px rgba(0,0,0,0.60), 0 0 0 1px rgba(255,255,255,0.04) inset",
          backdropFilter: "blur(10px)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* subtle gold glow */}
        <div
          style={{
            position: "absolute",
            right: -180,
            top: -160,
            width: 380,
            height: 380,
            background: `radial-gradient(circle at 30% 30%, rgba(245,158,11,0.22), transparent 62%)`,
            pointerEvents: "none",
          }}
        />

        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          {/* gold dot */}
          <div
            aria-hidden="true"
            style={{
              width: 12,
              height: 12,
              borderRadius: 999,
              background: gold,
              boxShadow: `0 0 0 4px rgba(245,158,11,0.14), 0 0 18px rgba(245,158,11,0.40)`,
              position: "relative",
              flex: "0 0 auto",
            }}
          >
            {/* pulse ring */}
            <div
              style={{
                position: "absolute",
                inset: -6,
                borderRadius: 999,
                border: `1px solid rgba(245,158,11,0.28)`,
                animation: "smInitPulse 1.2s ease-in-out infinite",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
            <div
              style={{
                fontSize: 15,
                fontWeight: 800,
                letterSpacing: 0.2,
                lineHeight: 1.15,
              }}
            >
              {title}
            </div>
            <div
              style={{
                fontSize: 13,
                lineHeight: 1.35,
                color: "rgba(255,255,255,0.70)",
              }}
            >
              {subtitle}
            </div>
          </div>
        </div>

        {/* progress bar */}
        <div
          aria-hidden="true"
          style={{
            marginTop: 14,
            height: 8,
            borderRadius: 999,
            background: "rgba(255,255,255,0.08)",
            overflow: "hidden",
            border: "1px solid rgba(255,255,255,0.06)",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "36%",
              background: `linear-gradient(90deg, rgba(245,158,11,0.18), rgba(245,158,11,0.70), rgba(245,158,11,0.35))`,
              animation: "smInitBar 1.15s ease-in-out infinite",
              filter: "saturate(1.05)",
            }}
          />
        </div>

        <style>{`
          @keyframes smInitBar {
            0% { transform: translateX(-120%); }
            100% { transform: translateX(320%); }
          }
          @keyframes smInitPulse {
            0%,100% { opacity: 0.35; transform: scale(1); }
            50% { opacity: 0.75; transform: scale(1.08); }
          }
        `}</style>
      </div>
    </div>
  );
}
